import type { TFunction } from "i18next";
import type { AuditChange, Catalogs } from "@/pages/Providers/types";

const fieldCatalog: Record<
    string,
    keyof Pick<
        Catalogs,
        | "types"
        | "specialities"
        | "countries"
        | "payment_methods"
        | "validation_states"
    >
> = {
    provider_type_id: "types",
    speciality_ids: "specialities",
    primary_speciality_id: "specialities",
    country_id: "countries",
    payment_method_id: "payment_methods",
    validation_state_id: "validation_states",
};

export const displayValue = (
    field: string,
    value: AuditChange["after"] | undefined,
    catalogs: Catalogs,
    t: TFunction
): string => {
    if (value == null || value === "") {
        return t("providers.ui.not_available");
    }
    const catalog = fieldCatalog[field];
    if (catalog) {
        return (Array.isArray(value) ? value : [value])
            .map(
                (id) =>
                    catalogs[catalog].find(
                        (option) => Number(option.id) === Number(id)
                    )?.name ?? t("providers.ui.unknown_catalog", { id })
            )
            .join(", ");
    }
    if (field === "payment_blocked") {
        return t(`providers.ui.${Number(value) ? "yes" : "no"}`);
    }
    if (field === "is_active") {
        return t(
            `providers.filters.state_${Number(value) === 1 ? "active" : "inactive"}`
        );
    }
    return Array.isArray(value) ? value.join(", ") : String(value);
};

export const displayDate = (value: string, language: string): string => {
    const date = new Date(
        /[zZ]$|[+-]\d\d:\d\d$/.test(value)
            ? value
            : `${value.replace(" ", "T")}Z`
    );
    return Number.isNaN(date.getTime()) ? value : date.toLocaleString(language);
};
